<section class="broadcast">
  <h1>Send email to candidates</h1>
  <p class="hint">Compose a message; it's sent with the Bipperz template (logo + greeting) to your chosen audience.</p>

  <div class="card">
    <label class="field">
      <span>Subject</span>
      <input type="text" [(ngModel)]="subject" name="subject" placeholder="e.g. New jobs available this week" />
    </label>

    <label class="field">
      <span>Message</span>
      <textarea [(ngModel)]="content" name="content" rows="8"
                placeholder="Write your message… line breaks are preserved."></textarea>
    </label>

    <div class="field">
      <span>Recipients</span>
      <div class="radios">
        <label class="radio">
          <input type="radio" name="target" [value]="BroadcastTarget.ALL_CANDIDATES"
                 [(ngModel)]="target" (ngModelChange)="onTargetChange()" />
          All candidates
        </label>
        <label class="radio">
          <input type="radio" name="target" [value]="BroadcastTarget.SELECTED"
                 [(ngModel)]="target" (ngModelChange)="onTargetChange()" />
          Selected candidates
        </label>
        <label class="radio">
          <input type="radio" name="target" [value]="BroadcastTarget.WITH_APPLICATION"
                 [(ngModel)]="target" (ngModelChange)="onTargetChange()" />
          Users with application(s)
        </label>
      </div>
    </div>

    <!-- With-application preview -->
    <div class="picker" *ngIf="target === BroadcastTarget.WITH_APPLICATION">
      <div *ngIf="loadingCandidates()" class="state">Loading…</div>
      <div *ngIf="!loadingCandidates() && candidatesLoaded()" class="state">
        {{ withApplicationCandidates().length }} user(s) with at least one application will receive this email.
      </div>
    </div>

    <!-- Candidate picker -->
    <div class="picker" *ngIf="target === BroadcastTarget.SELECTED">
      <div class="picker-head">
        <input type="text" class="search" [ngModel]="search()" (ngModelChange)="search.set($event)"
               name="search" placeholder="Search name or email…" />
        <div class="picker-actions">
          <span class="count">{{ selectedIds().size }} selected</span>
          <button type="button" class="link" (click)="selectAllFiltered()">Select all</button>
          <button type="button" class="link" (click)="clearSelection()">Clear</button>
        </div>
      </div>

      <div *ngIf="loadingCandidates()" class="state">Loading candidates…</div>
      <div *ngIf="candidatesLoaded() && filteredCandidates().length === 0" class="state">No candidates found.</div>

      <div class="candidate-list" *ngIf="!loadingCandidates()">
        <label class="candidate" *ngFor="let u of filteredCandidates()">
          <input type="checkbox" [checked]="isSelected(u.id)" (change)="toggle(u.id)" />
          <span class="c-name">{{ u.firstname }} {{ u.lastname }}</span>
          <span class="c-email">{{ u.email }}</span>
        </label>
      </div>
    </div>

    <div class="footer">
      <button class="btn primary" [disabled]="!canSend" (click)="send()">
        {{ sending() ? 'Sending…' : 'Send email' }}
      </button>
    </div>
  </div>
</section>
